import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class EnqueueOverdueBillsNotifyJob extends Relay.Mutation {
    static propTypes = {
        organisationId: PropTypes.string,
    };

    getMutation() { return Relay.QL`mutation { enqueueOverdueBillsNotifyJob }`; }

    getVariables() {
        return { organisationId: this.props.organisationId };
    }

    getFatQuery() {
        return Relay.QL`fragment on EnqueueOverdueBillsNotifyJobPayload { job { id, realId, status } }`;
    }

    getConfigs() {
        return [{ type: 'REQUIRED_CHILDREN', children: [this.getFatQuery()] }];
    }
}


